<ng-template>
	<button *ngIf="!hideCloseBtn" class="btn-modal-icon-close" type="button" mat-icon-button mat-dialog-close>
		<bp-svg-icon name="close"></bp-svg-icon>
	</button>

	<ng-container [ngTemplateOutlet]="content"></ng-container>
</ng-template>
